<template>
  <div class="login-page">
    <div class="bloc-connexion">
      <div cols="12" class="bloc-connexion__content">
          <v-col class="image-placeholder">
              <h1 class="text text-uppercase display-2 font-weight-bold">
                Bienvenue sur
              </h1>
              <div>
                <v-img
                class="my-5"
                src="/static/images/logo-spideup-white.png"
                width="300"
              ></v-img>
              </div>
              <p class="text text-login">
                Bienvenue sur la plateforme SpideUp, votre solution de mesure
                et de création de trafic dans votre point de vente
              </p>
              <p class="text text-login">
                Le meilleur de l'intéraction mobile pour votre clilentèle !
              </p>
              <v-row class="footer">
                <v-img class="white--text pl-2 pb-1">1G-Link © 2023</v-img>
              </v-row>
          </v-col>

          <v-col class="login-params">
            <v-row class="text weight-bold size-xlarge mb-5">
              <strong>Connexion</strong>
            </v-row>
            <v-row class="contact-bloc mb-7">
              <div>
                Vous n'avez pas de compte?
                <strong class="contact">Contactez-nous</strong>
              </div>
            </v-row>
            <v-row class="d-flex flex-column mb-7">
              <LoginInput
                class="login pt-0 pl-0 mb-3"
                v-model="email"
                placeholder="Entrez votre email"
                label="Identifiant"
                @on-enter="Login"
              />
              <v-text-field
                class="login pt-0 pl-0 mb-3"
                v-model="password"
                placeholder="Entrez votre mot de passe"
                label="Mot de passe"
                :append-icon="hiddenpassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="hiddenpassword ? 'text' : 'password'"
                @on-enter="Login"
              ></v-text-field>

              <!-- <v-col v-if="password !== ''">
                                <v-row class="pwd-indicator-title pl-0 pt-5">
                                    Sécurité : Votre mot de passe doit contenir :
                                </v-row>
                                <v-row class="pb-0">
                                    <v-col 
                                        class="pl-0"
                                        cols="1"
                                    >
                                        <v-icon class="check-icon" small>check_circle_outline</v-icon>
                                    </v-col>
                                    <v-col
                                        class="pwd-indicator-title" 
                                        cols="11"
                                    >
                                        Entre 8 et 16 caractéres au minimum
                                    </v-col>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col 
                                        class="pl-0"
                                        cols="1"
                                    >
                                        <v-icon class="check-icon" small>check_circle_outline</v-icon>
                                    </v-col>
                                    <v-col
                                        class="pwd-indicator-title" 
                                        cols="11"
                                    >
                                        Au moins un chiffre
                                    </v-col>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col 
                                        class="pl-0"
                                        cols="1"
                                    >
                                        <v-icon class="check-icon" small>check_circle_outline</v-icon>
                                    </v-col>
                                    <v-col
                                        class="pwd-indicator-title" 
                                        cols="11"
                                    >
                                        Au moins une minuscule
                                    </v-col>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col 
                                        class="pl-0"
                                        cols="1"
                                    >
                                        <v-icon class="wrong-icon" small>highlight_off</v-icon>
                                    </v-col>
                                    <v-col
                                        class="pwd-indicator-title" 
                                        cols="11"
                                    >
                                        Au moins une majuscule
                                    </v-col>
                                </v-row>
                            </v-col> -->

              <v-col class="password">
                <CheckBox
                  class=""
                  boxColor="#ffc306"
                  label="Se rappeler de moi"
                  :v-model="closed"
                />
                <router-link class="forgot-pwd pr-6" to="password"
                  >Mot de passe oublié?</router-link
                >
              </v-col>

              <v-col>
                <customButton
                  label="Se connecter"
                  btnType="connexion"
                  :elevation="0"
                  @click="Login"
                />
              </v-col>
            </v-row>
          </v-col>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import customButton from '@/components/buttons/customButton.vue';
import CheckBox from '@/components/input/checkboxInput.vue';
import LoginInput from '@/components/input/loginInput';
import TextInput from '@/components/input/textInput';
import checkDevice from '@/utils/checkDevice.js';

export default {
  components: {
    CheckBox,
    TextInput,
    customButton,
    LoginInput,
    checkDevice,
  },
  props: {},
  data() {
    return {
      password: '',
      email: '',
      closed: false,
      hiddenpassword: false,
      rules: {
        required: (value) => !!value || 'Mot de passe requis.',
      },
    };
  },
  methods: {
    Login() {
      const root = this
      const params = {
        email: this.email,
        password: this.password,
        error: () => {
          this.$store.commit('ui/hideloader', null, { root: true });
          this.$store.commit(
            'ui/triggerAlert',
            { type: 'error', msg: 'Connexion échoué' },
            { root: true },
          );
        },
        success: () => {
          this.$store.commit('ui/hideloader', null, { root: true });
          this.$store.commit(
            'ui/triggerAlert',
            { type: 'success', msg: 'Connexion réussie avec succès' },
            { root: true },
          );
          this.loadStore()
          this.$router.push({ name: 'DashboardV2' });
        },
      };
      this.$store.dispatch('auth/login', params);
    },
    loadStore() {
      this.$store.dispatch('segments/getSegments')
      this.$store.dispatch('scenarios/scenariosData')
    }
  },
  created() {},
};
</script>

<style lang="scss">
.text-login {
  position: relative;
  color: #ffffff;
  font-size: 18px !important;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.2px;
}

.footer {
  position: absolute;
  top: 95%;
  left: 15%;
  transform: translate(-50%, -50%);
}

.label {
  font-size: 18px !important;
}
</style>
